export default {
  节点标识: '节点标识',
  节点地址: '节点地址',
  节点名称: '节点名称',
  系统版本: '系统版本',
  '使用率(%)': '使用率(%)',
  速度: '速度',
  '最大值(GB)': '最大值(GB)',
  '速度(B/s)': '速度(B/s)',
  温度: '温度',
  时间: '时间',
  提示: '提示',
  终端地址为空: '终端地址为空',
  'AidLux Web终端': 'AidLux Web终端',
  '节点数据不存在，不能导出': '节点数据不存在，不能导出',
  '资源监控-{slot0}.csv': '资源监控-{slot0}.csv',
  显示区间: '显示区间',
  刷新: '刷新',
  刷新间隔: '刷新间隔',
  开始: '开始',
  停止: '停止',
  'CSV-所有数据': 'CSV-所有数据',
  'CSV-当前数据': 'CSV-当前数据',
  导出数据: '导出数据',
  小时: '小时',
  分钟: '分钟',
  秒: '秒',
  '3秒': '3秒',
  '30秒': '30秒',
  '1分钟': '1分钟',
  '15分钟': '15分钟',
  '30分钟': '30分钟',
  '1小时': '1小时',
  天: '天',
  '15分钟前': '15分钟前',
  前: '前',
  相对时间: '相对时间',
  绝对时间: '绝对时间',
  现在: '现在',
  '目标：': '目标：',
  开始时间不能大于结束时间: '开始时间不能大于结束时间',
  结束时间不能小于开始时间: '结束时间不能小于开始时间',
  至: '至',
  AccessKey管理: 'AccessKey管理',
  修改密码: '修改密码',
  退出登录: '退出登录',
  关闭: '关闭',
  重新生成: '重新生成',
  修改成功: '修改成功',
  '密码修改成功，请重新登录': '密码修改成功，请重新登录',
  原密码: '原密码',
  请输入原密码: '请输入原密码',
  新密码: '新密码',
  请输入新密码: '请输入新密码',
  确认密码: '确认密码',
  请输入确认密码: '请输入确认密码',
  Logo设置: 'Logo设置',
  是否显示Logo: '是否显示Logo',
  显示: '显示',
  隐藏: '隐藏',
  Logo图片: 'Logo图片',
  图片大小不能超过2M: '图片大小不能超过2M',
  名称不能超过255个字符: '名称不能超过255个字符',
  还原: '还原',
  '授权到期日期:': '授权到期日期:',
  永久: '永久',
  无: '无',
  失败: '失败',
  未集成: '未集成',
  集成中: '集成中',
  已集成: '已集成',
  普通模式: '普通模式',
  商业ROOT版: '商业ROOT版',
  商业版: '商业版',
  是: '是',
  否: '否',
  安装配置中: '安装配置中',
  计划等待中: '计划等待中',
  下载安装包: '下载安装包',
  任务成功: '任务成功',
  任务失败: '任务失败',
  任务终止: '任务终止',
  立即升级: '立即升级',
  指定时间: '指定时间',
  异常页: '异常页',
  '对不起，您没有访问该资源的权限': '对不起，您没有访问该资源的权限',
  返回: '返回',
  严重级别: '严重级别',
  发生时间: '发生时间',
  事件源: '事件源',
  请输入事件源: '请输入事件源',
  事件类型: '事件类型',
  事件内容: '事件内容',
  操作: '操作',
  '确认删除此项告警吗?': '确认删除此项告警吗?',
  '告警管理-{mo}.csv': '告警管理-{mo}.csv',
  删除成功: '删除成功',
  已取消上传: '已取消上传',
  新增应用: '新增应用',
  '该应用正在部署中,不能覆盖': '该应用正在部署中,不能覆盖',
  '该应用已存在,是否覆盖?': '该应用已存在,是否覆盖?',
  新增应用成功: '新增应用成功',
  应用名称: '应用名称',
  英文名称: '英文名称',
  应用版本: '应用版本',
  更新日志: '更新日志',
  '描 述': '描 述',
  创建部署任务成功: '创建部署任务成功',
  分组名称: '分组名称',
  输入分组名称: '输入分组名称',
  输入节点名称: '输入节点名称',
  已部署版本: '已部署版本',
  移除: '移除',
  应用部署: '应用部署',
  取消: '取消',
  确定: '确定',
  节点列表: '节点列表',
  全部: '全部',
  已选中: '已选中',
  选中: '选中',
  条: '条',
  条1: '条',
  暂未部署: '暂未部署',
  部署时间: '部署时间',
  已部署节点: '已部署节点',
  序号: '序号',
  名称: '名称',
  最新版本: '最新版本',
  描述: '描述',
  大小: '大小',
  上传时间: '上传时间',
  部署: '部署',
  '当前应用的所有版本都将删除,确认删除吗?': '当前应用的所有版本都将删除,确认删除吗?',
  删除: '删除',
  '新 增': '新 增',
  '所选中应用的所有版本都将删除,确认删除吗?': '所选中应用的所有版本都将删除,确认删除吗?',
  '删 除': '删 除',
  请输入应用名称: '请输入应用名称',
  版本: '版本',
  '确认删除吗?': '确认删除吗?',
  部署详情: '部署详情',
  部署状态: '部署状态',
  进行中: '进行中',
  部署成功: '部署成功',
  部署失败: '部署失败',
  部署日志: '部署日志',
  全部日志: '全部日志',
  实时日志: '实时日志',
  节点总数: '节点总数',
  状态: '状态',
  部署中: '部署中',
  '部署中:{slot0}': '部署中:{slot0}',
  '部署成功:{slot0}': '部署成功:{slot0}',
  '部署失败:{slot0}': '部署失败:{slot0}',
  '将重新部署所有节点,确认重新部署吗?': '将重新部署所有节点,确认重新部署吗?',
  重新部署任务创建成功: '重新部署任务创建成功',
  重新部署: '重新部署',
  请选择应用: '请选择应用',
  请选择应用版本: '请选择应用版本',
  请输入节点名称: '请输入节点名称',
  请输入分组名称: '请输入分组名称',
  完成时间: '完成时间',
  '确认重新部署吗?': '确认重新部署吗?',
  重新创建部署任务成功: '重新创建部署任务成功',
  详情: '详情',
  运行日志: '运行日志',
  应用状态: '应用状态',
  已停止: '已停止',
  运行中: '运行中',
  '确认重启运行的服务吗?': '确认重启运行的服务吗?',
  重启成功: '重启成功',
  重启: '重启',
  '确认启动服务吗?': '确认启动服务吗?',
  启动成功: '启动成功',
  启动: '启动',
  '确定停止运行的服务吗?': '确定停止运行的服务吗?',
  停止成功: '停止成功',
  '确认卸载吗?': '确认卸载吗?',
  卸载成功: '卸载成功',
  卸载: '卸载',
  新增节点成功: '新增节点成功',
  编辑节点: '编辑节点',
  新增节点: '新增节点',
  超过最大长度20: '超过最大长度20',
  '设备管理.csv': '设备管理.csv',
  导出配置: '导出配置',
  节点状态: '节点状态',
  节点状态不能为空: '节点状态不能为空',
  请选择节点状态: '请选择节点状态',
  在线: '在线',
  离线: '离线',
  创建部署任务: '创建部署任务',
  固件名称: '固件名称',
  固件版本: '固件版本',
  执行时间: '执行时间',
  已取消上传固件包: '已取消上传固件包',
  固件新增成功: '固件新增成功',
  固件新增: '固件新增',
  请上传固件: '请上传固件',
  固件类型: '固件类型',
  整包: '整包',
  差分: '差分',
  待升级版本: '待升级版本',
  选择固件: '选择固件',
  上传固件: '上传固件',
  请添加描述信息: '请添加描述信息',
  超过最大长度200: '超过最大长度200',
  请添加固件说明: '请添加固件说明',
  未开始: '未开始',
  重启中: '重启中',
  开始时间: '开始时间',
  '确定重新部署吗？': '确定重新部署吗？',
  '确定删除吗？': '确定删除吗？',
  设备状态: '设备状态',
  执行时间修改成功: '执行时间修改成功',
  编辑部署任务: '编辑部署任务',
  立即执行: '立即执行',
  '确定删除该固件吗？': '确定删除该固件吗？',
  新增: '新增',
  '确定删除所选固件吗？': '确定删除所选固件吗？',
  请输入固件名称: '请输入固件名称',
  '最大支持固件数:': '最大支持固件数:',
  个: '个',
  '进行中:{slot0}': '进行中:{slot0}',
  成功: '成功',
  '成功:{slot0}': '成功:{slot0}',
  '失败:{slot0}': '失败:{slot0}',
  编辑: '编辑',
  '确定删除该任务吗?': '确定删除该任务吗?',
  删除任务成功: '删除任务成功',
  '确定删除所选任务吗?': '确定删除所选任务吗?',
  删除所选任务成功: '删除所选任务成功',
  设备码: '设备码',
  唯一标识: '唯一标识',
  唯一标识复制成功: '唯一标识复制成功',
  集成命令: '集成命令',
  集成命令复制成功: '集成命令复制成功',
  编辑成功: '编辑成功',
  日志: '日志',
  软件包ID: '软件包ID',
  软件版本: '软件版本',
  已取消上传软件包: '已取消上传软件包',
  软件包新增成功: '软件包新增成功',
  软件包新增: '软件包新增',
  选择软件包: '选择软件包',
  上传软件包: '上传软件包',
  '确定删除该软件包吗？': '确定删除该软件包吗？',
  '确定删除所选软件包吗？': '确定删除所选软件包吗？',
  请输入软件包ID: '请输入软件包ID',
  '最大支持软件数:': '最大支持软件数:',
  '确定删除吗?': '确定删除吗?',
  节点分组: '节点分组',
  Soc厂商: 'Soc厂商',
  系统SN: '系统SN',
  设备序列号: '设备序列号',
  Soc型号: 'Soc型号',
  Soc详情: 'Soc详情',
  属性: '属性',
  内容: '内容',
  基本信息: '基本信息',
  硬件信息: '硬件信息',
  固件管理: '固件管理',
  部署记录: '部署记录',
  地址: '地址',
  系统: '系统',
  启用: '启用',
  导入节点: '导入节点',
  批量删除: '批量删除',
  '最大支持设备数:': '最大支持设备数:',
  不可导入: '不可导入',
  可导入: '可导入',
  说明: '说明',
  '确认删除吗？': '确认删除吗？',
  节点新增成功: '节点新增成功',
  上传文件: '上传文件',
  网络分组: '网络分组',
  请输入网络分组: '请输入网络分组',
  节点名称不能为空: '节点名称不能为空',
  '导入模板:': '导入模板:',
  '节点导入模板.csv': '节点导入模板.csv',
  点我下载: '点我下载',
  '可导入节点{slot0}个,不可导入节点{slot1}个,是否继续?': '可导入节点{slot0}个,不可导入节点{slot1}个,是否继续?',
  软件包管理: '软件包管理',
  首页: '首页',
  '欢迎使用 Node Master': '欢迎使用 Node Master',
  '用户名:': '用户名:',
  '密码:': '密码:',
  '登 录': '登 录',
  注册成功: '注册成功',
  '欢迎使用AidLux NodeMaster': '欢迎使用AidLux NodeMaster',
  用户名: '用户名',
  必填项: '必填项',
  昵称: '昵称',
  密码: '密码',
  密码不一致: '密码不一致',
  '注 册': '注 册',
  创建命令: '创建命令',
  修改命令: '修改命令',
  命令详情: '命令详情',
  创建成功: '创建成功',
  命令名称: '命令名称',
  请输入命令名称: '请输入命令名称',
  '支持中文、字母、数字、下划线、分隔符"-",最大长度不超过60个字符': '支持中文、字母、数字、下划线、分隔符"-",最大长度不超过60个字符',
  命令描述: '命令描述',
  不超过200个字符: '不超过200个字符',
  请输入命令描述: '请输入命令描述',
  执行路径: '执行路径',
  请输入执行路径: '请输入执行路径',
  执行用户: '执行用户',
  超时时间: '超时时间',
  '可设置范围1～86400秒,默认60秒。超时后,会强制终止发送进程': '可设置范围1～86400秒,默认60秒。超时后,会强制终止发送进程',
  请输入超时时间: '请输入超时时间',
  '请输入1-86400之间的数字': '请输入1-86400之间的数字',
  默认为60: '默认为60',
  命令内容: '命令内容',
  请输入命令: '请输入命令',
  执行命令下发成功: '执行命令下发成功',
  执行命令: '执行命令',
  复制成功: '复制成功',
  修改时间: '修改时间',
  执行: '执行',
  修改: '修改',
  请输入命令名称或描述: '请输入命令名称或描述',
  结果: '结果',
  执行状态: '执行状态',
  执行成功: '执行成功',
  执行失败: '执行失败',
  '成功:': '成功:',
  '失败:': '失败:',
  '执行中:': '执行中:',
  执行时长: '执行时长',
  '确认终止吗?': '确认终止吗?',
  终止成功: '终止成功',
  终止: '终止',
  '确认重新执行吗?': '确认重新执行吗?',
  重新执行成功: '重新执行成功',
  重新执行: '重新执行',
  节点IP: '节点IP',
  执行中: '执行中',
  查看执行输出: '查看执行输出',
  命令管理: '命令管理',
  执行记录: '执行记录',
  保存成功: '保存成功',
  保存: '保存',
  下发成功: '下发成功',
  文件下发: '文件下发',
  下发路径: '下发路径',
  NM根路径: 'NM根路径',
  远程下载: '远程下载',
  '远程下载正在进行中,确认取消吗？': '远程下载正在进行中,确认取消吗？',
  远程下载已取消: '远程下载已取消',
  '文件已存在，是否覆盖': '文件已存在，是否覆盖',
  URL地址: 'URL地址',
  请输入URL地址: '请输入URL地址',
  URL地址不合法: 'URL地址不合法',
  文件地址: '文件地址',
  文件名: '文件名',
  请输入文件名: '请输入文件名',
  文件名不合法: '文件名不合法',
  '文件名/夹': '文件名/夹',
  '权限/所有者': '权限/所有者',
  文件大小: '文件大小',
  计算: '计算',
  重命名: '重命名',
  分享: '分享',
  我的文件: '我的文件',
  请输入文件或目录名: '请输入文件或目录名',
  上传: '上传',
  新建文件夹: '新建文件夹',
  分享列表: '分享列表',
  下发: '下发',
  '存储空间:': '存储空间:',
  文件夹名: '文件夹名',
  请输入文件夹名: '请输入文件夹名',
  文件夹名不合法: '文件夹名不合法',
  '重命名文件/夹': '重命名文件/夹',
  创建分享: '创建分享',
  分享名称: '分享名称',
  请输入分享名称: '请输入分享名称',
  名称不能为空: '名称不能为空',
  有效期: '有效期',
  请选择有效期: '请选择有效期',
  一天: '一天',
  七天: '七天',
  分享详情: '分享详情',
  分享地址: '分享地址',
  过期时间: '过期时间',
  '共(': '共(',
  '个文件)': '个文件)',
  上传状态: '上传状态',
  等待上传: '等待上传',
  上传失败: '上传失败',
  上传成功: '上传成功',
  '文件上传中,关闭将会取消上传,确定取消上传吗？': '文件上传中,关闭将会取消上传,确定取消上传吗？',
  '存在以下重名文件,是否覆盖?': '存在以下重名文件,是否覆盖?',
  选择不覆盖将会把重名文件从上传列表中去除: '选择不覆盖将会把重名文件从上传列表中去除',
  取消上传: '取消上传',
  不覆盖: '不覆盖',
  覆盖: '覆盖',
  开始上传: '开始上传',
  上传文件夹: '上传文件夹',
  清空列表: '清空列表',
  单个文件不允许超过5GB: '单个文件不允许超过5GB',
  文件管理: '文件管理',
  下发记录: '下发记录',
  下发状态: '下发状态',
  下发失败: '下发失败',
  '下发中:': '下发中:',
  下发时间: '下发时间',
  '确认重新下发吗?': '确认重新下发吗?',
  重新下发成功: '重新下发成功',
  重新下发: '重新下发',
  下发中: '下发中',
  设备管理: '设备管理',
  设备列表: '设备列表',
  设备详情: '设备详情',
  告警管理: '告警管理',
  事件监控: '事件监控',
  数据分析: '数据分析',
  资源监控: '资源监控',
  应用管理: '应用管理',
  应用中心: '应用中心',
  配置管理: '配置管理',
  远程文件: '远程文件',
  远程命令: '远程命令',
  服务器错误: '服务器错误',
  请求参数错误: '请求参数错误',
  登陆已过期: '登陆已过期',
  请求地址不存在: '请求地址不存在',
  请求失败: '请求失败',
  '请求数据异常，请稍后再试!': '请求数据异常，请稍后再试!',
  '网络连接异常，请稍后再试!': '网络连接异常，请稍后再试!',
  小于1秒: '小于1秒',
  '{days}天{hours}时': '{days}天{hours}时',
  '{hours}时{minutes}分': '{hours}时{minutes}分',
  '{minutes}分{secs}秒': '{minutes}分{secs}秒',
  '{secs}秒': '{secs}秒',
  '暂无数据，不能导出': '暂无数据，不能导出',
  连接断开: '连接断开',
  连接正常: '连接正常',
  特别严重: '特别严重',
  严重: '严重',
  较重: '较重',
  一般: '一般',
  硬件设备: '硬件设备',
  网络通信: '网络通信',
  处理异常: '处理异常'
};